export default function FileDeliverableIndexSelector(
  deliverableType: string,
  files: File[]|FileList,
  excludeIndexes: number[],
): number|null {
  console.log(deliverableType);
  let currentFileIndex = null;
  switch (deliverableType) {
    case 'video-file':
      for (let i = 0; i < files.length; i += 1) {
        if (excludeIndexes.includes(i)) {
          continue;
        }
        if (
          files[i].name.includes('mp4')
          || files[i].name.includes('mov')
        ) {
          currentFileIndex = i;
          return currentFileIndex;
        }
      }
      break;
    case 'image-file':
    case 'image':
      for (let i = 0; i < files.length; i += 1) {
        if (excludeIndexes.includes(i)) {
          continue;
        }
        if (
          files[i].name.includes('jpg')
          || files[i].name.includes('png')
        ) {
          currentFileIndex = i;
          return currentFileIndex;
        }
      }
      break;
    case 'zip-file':
    case 'zip':
      for (let i = 0; i < files.length; i += 1) {
        if (excludeIndexes.includes(i)) {
          continue;
        }
        if (
          files[i].name.includes('zip')
        ) {
          currentFileIndex = i;
          return currentFileIndex;
        }
      }
      break;
    default:
      currentFileIndex = null;
  }
  return currentFileIndex;
}
